<template>
  <div>
    <div class="payment-link-order">
      <el-form ref="form" :model="form" label-width="250px" label-position="left">
        <div class="title">{{ $t('payment_links.customer_payin_journey') }}</div>
        <div class="tableContainer">
          <el-table
            :data="tableData"
            stripe
            fit
            style="width: 100%"
            max-height="500"
          >
            <el-table-column :label="$t('payment_links.transaction_id')" align="center">
              <template slot-scope="scope">
                {{ scope.row.transaction_id }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('payment_links.payment_channel')" align="center">
              <template slot-scope="scope">
                {{ scope.row.payment_channel }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('payment_links.payment_status')" min-width="85" align="center">
              <template slot-scope="scope">
                <el-tag class="tag-custom" :type="getCheckoutOrderStatusMap(scope.row.transaction_status).type"> {{ getCheckoutOrderStatusMap(scope.row.transaction_status).label }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column :label="$t('payment_links.amount')" align="center">
              <template slot-scope="scope">
                {{ scope.row.transaction_amount | toDivideWithDot }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('payment_links.create_time')" min-width="108" align="center">
              <template slot-scope="scope">
                {{ scope.row.transaction_create_time }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('payment_links.complete_time')" min-width="108" align="center">
              <template slot-scope="scope">
                {{ scope.row.transaction_return_time }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('components.operation')" align="center">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">
                    <span> {{ $t('components.detail') }}</span>
                  </div>
                  <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row.transaction_id)" />
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </el-form>
    </div>
  </div>
</template>

<script>
import { payTransactionStatusMap } from '@/utils/maps'

export default {
  name: 'Transaction_Detail',
  props: {
    transactionData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: [],
      form: {}
    }
  },
  computed: {
    getCheckoutOrderStatusMap() {
      return val => payTransactionStatusMap(val)
    }
  },
  watch: {
    transactionData(newVal) {
      this.form = newVal.payment_checkout_order
      this.tableData = newVal.transaction_list
      this.fieldInfoList = newVal.payment_link_checkout.field_info_list
    }
  },
  methods: {
    onClickDetailBtn(transaction_id) {
      this.$emit('onClickDetailBtn', transaction_id)
    }
  }
}
</script>

<style lang = "scss" scoped>
.payment-link-order{
  .title{
    font-size: 16px;
    color: #000;
    font-weight: 600;
    padding: 24px 24px 12px;
    border-bottom: 1px solid #D3D7DF;
    margin-bottom: 12px;
  }
  .tableContainer{
    margin: 36px 24px 24px;
  }
  ::v-deep .el-form-item{
    padding-right: 24px;
    margin-bottom: 0;
    .el-form-item__label{
      padding-left: 24px;
      color: #1D3A71;
      font-family: Inter;
      font-weight: 600;
    }
    .content-text{
      color: #1D3A71;
      font-family: Inter;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .tag-custom{
    border-radius: 28px;
    padding: 0 13px;
    height: 28px;
    line-height: 28px;
    border: none;
    vertical-align: middle;
    &.el-tag--info{
      color: #B45309;
      background-color: #FDE68A;
    }
    &.el-tag--success{
      color: #047857;
      background-color: #A7F3D0;
    }
    &.el-tag--danger{
      color: #71110E;
      background-color: #FCA5A5;
    }
  }
}
</style>

